import React, { Component } from 'react';
import {bindActionCreators} from "redux";
import { connect } from 'react-redux';
import { RoutesApp } from '../Routes';

import * as UserActions from 'store/modules/UserModule';
import * as DataActions from 'store/modules/DataModule';

import './App.css';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    async componentDidMount() {

    }

    render() {
        return (
            <RoutesApp />
        );
    }
}



let mapStateToProps = (state) => ({
    myPublicAddress: JSON.parse(JSON.stringify(state.DataModule.get('myPublicAddress')))
});

let mapDispatchToProps = (dispatch) => ({
    userActions: bindActionCreators(UserActions, dispatch),
    dataActions: bindActionCreators(DataActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

